"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dotMargin = exports.dotHeight = undefined;

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var dotHeight = exports.dotHeight = function dotHeight(props) {
  return props.dotHeight + "px";
};

var dotMargin = exports.dotMargin = function dotMargin(props) {
  return "0 " + c.px(Math.floor(props.dotHeight / 3));
};